module.exports = __webpack_public_path__ + "img/download_and.ab2abcae.png";